import React from "react"
import {HashRouter as Router, Route, Routes} from "react-router-dom"
import {observer} from "mobx-react";
import MedicalEvents from "../../admin/Console/MedicalEvents/MedicalEvents";
import CreateMedicalEvent from "../../admin/Console/MedicalEvents/CreateMedicalEvent";


const MedicalEventsRouter = observer(() => {

    return <div id="in-progress-event-view">
        <Router>
            <Routes>
                <Route path="/medical_events" exact element={<MedicalEvents/>}/>
                <Route path="medical_events/new" exact element={<CreateMedicalEvent/>}/>
                <Route path="medical_events/edit/:id" exact element={<CreateMedicalEvent/>}/>
            </Routes>
        </Router>
    </div>
})

export default MedicalEventsRouter